import { render, staticRenderFns } from "./CourseDirectionBigData.vue?vue&type=template&id=7635193b&scoped=true&"
import script from "./CourseDirectionBigData.vue?vue&type=script&lang=js&"
export * from "./CourseDirectionBigData.vue?vue&type=script&lang=js&"
import style0 from "./CourseDirectionBigData.vue?vue&type=style&index=0&id=7635193b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7635193b",
  null
  
)

export default component.exports